module.exports = __webpack_public_path__ + "static/img/act-steps-m-4-hk.04f1d88.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-m-4-hk.png
// module id = t/m8
// module chunks = 1